import React from 'react'
import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'

import Routes from 'commons/js/routes/routes'

import VehicleInspectionProductSelectorContainer from '../containers'

class VehicleInspectionProductSelector extends React.Component {
    static propTypes = {
        product: PropTypes.object,
        vehicleInspectionStation: PropTypes.object,
    }
    render () {
        const { product, vehicleInspectionStation } = this.props

        return (
            <Route
              path={Routes.vehicleInspectionStationPath()}
              render={(props) =>
                  <VehicleInspectionProductSelectorContainer
                    defaultProduct={product}
                    vehicleInspectionStation={vehicleInspectionStation}
                    {...props} />
              }
            />
        )
    }
}

export default VehicleInspectionProductSelector
